import { cx } from '@mage-ui/styled-system/css';
import {
  button,
  link as linkRecipe,
  rowCardLite,
  text,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { useState } from 'react';
import { BubblePlaceholder } from '../../images/bubble-placeholder/BubblePlaceholder';
import { ImageRound } from '../../images/image-round/ImageRound';
import { RoundPlaceholder } from '../../images/round-placeholder/RoundPlaceholder';

// MiniCardLiteItem
export const RowCardLite = ({ data, ...props }) => {
  const [hasError, setHasError] = useState(false);

  const href = data?.email ? `mailto:${data?.email}` : data?.cta_slug;
  const content = data?.email ? data?.email : data?.cta_text;
  const linkClass = data?.email
    ? linkRecipe({ size: 'xs', weight: 'medium', variant: 'underlined' })
    : button({ size: 's' });

  const hasImgProp = Object.prototype.hasOwnProperty.call(
    data,
    'img_mini_card',
  );

  const noImg =
    hasError ||
    (typeof data?.img_mini_card === 'string' &&
      data.img_mini_card.trim().length === 0);

  const noTitle = !data?.title || data.title.trim().length === 0;

  return (
    <div className={rowCardLite().root} {...props}>
      {hasImgProp && (
        <div className={rowCardLite().imageWrapper}>
          {noImg ? (
            noTitle ? (
              <RoundPlaceholder texts={{ a11yText: data?.placeholder }} />
            ) : (
              <BubblePlaceholder title={data?.title} />
            )
          ) : (
            <ImageRound
              src={data?.img_mini_card}
              alt={data?.alt_img ?? data?.title}
              sizes={{ width: 98, height: 98 }}
              className={rowCardLite().image}
              onError={() => setHasError(true)}
            />
          )}
        </div>
      )}

      <div className={rowCardLite().contentWrapper}>
        <h3 className={cx(text({ size: '2', weight: 'semiBold' }))}>
          {data?.title}
        </h3>

        <p
          className={cx(text({ size: '4', weight: 'medium' }))}
          dangerouslySetInnerHTML={{ __html: data?.description }}
        />

        {href !== null && href?.length > 0 && (
          <Link href={href} className={linkClass}>
            {content}
          </Link>
        )}
      </div>
    </div>
  );
};
